export default {
  dcourierControlSign: '/activationScore/client/courierControlSign'
}
